const sarjKontrol = [
  {
    "title": "TommaTech 45A 12/24 2USB PWM Şarj Kontrol Chz.",
    "image": "https://cw-enerji.com/images/product/1390_tommatech-45a-1224-2usb-pwm-sarj-kontrol-chz_0.png",
    "text": "- Yüksek Kaliteli Bileşenler ve Standartları\n- Dinamik LCD Ekran Dizaynı\n- Elektronik Cihazlar için Çift USB\n- Çoklu Yük Kontrol Modları\n- Enerji İstatistikleri Fonksiyonu",
    "variants": []
  },
  {
    "title": "TommaTech S 60A 12/24/48V MPPT Şarj Kontrol Chz.",
    "image": "https://cw-enerji.com/images/product/417_tommatech-s-60a-122448v-mppt-sarj-kontrol-chz_0.webp",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel LCD Ekran\n- Aşırı Sıcaklık Koruması\n- Çoklu Yük Kontrol Modları\n- Ters Polarite Koruması\n- Aşırı Şarj ve Aşırı Yük Koruma\n- Farklı Batarya Teknolojileri ile Uyumluluk",
    "variants": []
  }
];

export default sarjKontrol;
